module.exports = __webpack_public_path__ + "static/media/hero-home.7c1825f5.png";